module.exports = __webpack_public_path__ + "static/media/vegitables_40.c2d5a367.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_40.csv
// module id = 625
// module chunks = 0